module.exports = __webpack_public_path__ + "img/no-photo.8cc398eb.svg";